import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../Pages/Dashboard";
import DonneesBases from "../Pages/DonneesBases";
import FournisseursSoins from "../Pages/FournisseursSoins";
import Adherents from "../Pages/Adherents";
import ViewFournisseurPage from "../Pages/Modal/ViewFournisseurPage";
import EditFournisseur from "../Pages/Modal/EditFournisseur";
import DemandeAdhs from "../Pages/DemandeAdhs";
import Participants from "../Pages/Participants";
import DetailsParticipant from "../Pages/Modal/DetailsParticipant";
import EditParticipant from "../Pages/Modal/EditParticipant";
import BonsPharma from "../Pages/BonsPharma";

import LgHospi from "../Pages/LgHospi";
import BonsOptique from "../Pages/BonsOptique";
import FacsSocs from "../Pages/FacsSocs";
import OrdrePaie from "../Pages/OrdrePaie";
import BonsAchat from "../Pages/BonsAchat";
import Lettregarant from "../Pages/Lettregarant";
import Factures from "../Pages/Factures";
import TraitementFacture from "../Pages/Modal/TraitementFacture";
import Tpec from "../Pages/Tpec";
import JournalCentral from "../Pages/JournalCentral";
import SaisieJournal from "../Pages/SaisieJournal";
import PlanCompta from "../Pages/PlanCompta";
import IntCompte from "../Pages/IntCompte";
import RappBanque from "../Pages/RappBanque";
import Immobilisation from "../Pages/Immobilisation";
import Budget from "../Pages/Budget";
import SaisieCotisations from "../Pages/SaisieCotisations";
import ReglementFacture from "../Pages/ReglementFacture";
import Retenue from "../Pages/Retenue";
import Remboursements from "../Pages/Remboursements";
import Suspensions from "../Pages/Suspensions";
import EtatComptaFin from "../Pages/EtatComptaFin";
import GestionPaie from "../Pages/GestionPaie";
import ReportExport from "../Pages/ReportExport";
import Bulletins from "../Pages/Bulletins";
import Utilisateurs from "../Pages/Utilisateurs";
import EditPage from "../Pages/EditPage";
import InfosGen from "../Pages/InfosGen";
import TextReglement from "../Pages/TextReglement";
import Profil from "../Pages/Profil";
import TicketRemb from "../Pages/TicketRemb";
import OrganeIpm from "../Pages/OrganeIpm";
import Informations from "../Pages/Informations";
import PDFViewer from "../Pages/PDFViewer";
import DetailsActes from "../Pages/DetailsActes";
import EnteteSignature from "../Pages/EnteteSignature";
import FactureAdht from "../Pages/FactureAdht";

export default function AppRoutes() {
    return (
        <div>
            <Routes>
                <Route path="/" element={<Dashboard />}></Route>
                <Route path="/dashboard" element={<Dashboard />}></Route>
                <Route path="/donnees_bases" element={<DonneesBases />}></Route>
                <Route path="/tauxpc" element={<Tpec />}></Route>
                <Route path="/adherents" element={<Adherents />}></Route>
                <Route path="/fichiers/societes" element={<DemandeAdhs />}></Route>
                <Route path="/ticket_remboursement" element={<TicketRemb />}></Route>
                <Route path="/participants" element={<Participants />}></Route>
                <Route
                    path="/participants/view/:numcont"
                    element={<DetailsParticipant />}
                ></Route>
                <Route
                    path="/participants/edit/:numcont"
                    element={<EditParticipant />}
                ></Route>
                <Route path="/fournisseurs" element={<FournisseursSoins />}></Route>
                <Route
                    path="/fournisseurs/view/:numFourn"
                    element={<ViewFournisseurPage />}
                ></Route>
                <Route
                    path="/fournisseurs/edit/:numFourn"
                    element={<EditFournisseur />}
                ></Route>
                <Route path="/bons_pharmacies" element={<BonsPharma />}></Route>
                <Route path="lettres_garanties" element={<Lettregarant />}></Route>
                <Route path="/lg_hospitalisation" element={<LgHospi />}></Route>
                <Route path="/bons_optiques" element={<BonsOptique />}></Route>
                <Route path="/saisie_journal" element={<SaisieJournal />}></Route>
                <Route path="/immobilisation" element={<Immobilisation />}></Route>
                <Route path="/budget" element={<Budget />}></Route>
                <Route path="/saisie_encaissement" element={<FacsSocs />}></Route>
                <Route path="/details_actes" element={<DetailsActes />}></Route>
                <Route path="/ordre_paiement" element={<OrdrePaie />}></Route>
                <Route path="/plancompta" element={<PlanCompta />}></Route>
                <Route path="/rapport_banque" element={<RappBanque />}></Route>
                <Route path="/interrogation_compte" element={<IntCompte />}></Route>
                <Route path="/cotisations" element={<SaisieCotisations />}></Route>
                <Route path="/reglements" element={<ReglementFacture />}></Route>
                <Route path="/etat_comptafin" element={<EtatComptaFin />}></Route>
                <Route path="/retenues" element={<Retenue />}></Route>
                <Route path="/remboursements" element={<Remboursements />}></Route>
                <Route path="/suspensions" element={<Suspensions />}></Route>
                <Route path="/journal-central" element={<JournalCentral />}></Route>
                <Route path="/bulletins" element={<Bulletins />}></Route>
                <Route path="/gestion-paie" element={<GestionPaie />}></Route>
                <Route path="/bon_achat" element={<BonsAchat />}></Route>
                <Route path="/reporting" element={<ReportExport />}></Route>
                <Route path="/profil" element={<Profil />}></Route>
                <Route path="/factures" element={<Factures />}></Route>
                <Route
                    path="/factures/show/:numenreg"
                    element={<TraitementFacture />}
                ></Route>
                <Route path="/users" element={<Utilisateurs />}></Route>
                <Route path="/infosgen" element={<InfosGen />}></Route>
                <Route path="/informations" element={<Informations />}></Route>
                <Route path="/organe-ipm" element={<OrganeIpm />}></Route>
                <Route path="/pdfviewer" element={<PDFViewer />}></Route>
                <Route path="/gestion-paie/edit/:numbull" element={<EditPage />} />
                <Route path="/text&reglement" element={<TextReglement />}></Route>
                <Route path="/Entête&Signature" element={<EnteteSignature />}></Route>
                <Route path="/Facture_Adherent" element={<FactureAdht />}></Route>
            </Routes>
        </div>
    );
}

/* import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from '../Pages/Dashboard';
import DonneesBases from '../Pages/DonneesBases';
import FournisseursSoins from '../Pages/FournisseursSoins';
import Adherents from '../Pages/Adherents';
import ViewFournisseurPage from '../Pages/Modal/ViewFournisseurPage';
import EditFournisseur from '../Pages/Modal/EditFournisseur';
import DemandeAdhs from '../Pages/DemandeAdhs';
import Participants from '../Pages/Participants';
import DetailsParticipant from '../Pages/Modal/DetailsParticipant';
import EditParticipant from '../Pages/Modal/EditParticipant';
import BonsPharma from '../Pages/BonsPharma';
import LgHospi from '../Pages/LgHospi';
import BonsOptique from '../Pages/BonsOptique';
import FacsSocs from '../Pages/FacsSocs';
import OrdrePaie from '../Pages/OrdrePaie';
import BonsAchat from '../Pages/BonsAchat';
import Lettregarant from '../Pages/Lettregarant';
import Factures from '../Pages/Factures';
import TraitementFacture from '../Pages/Modal/TraitementFacture';
import Tpec from '../Pages/Tpec';
import JournalCentral from '../Pages/JournalCentral';
import SaisieJournal from '../Pages/SaisieJournal';
import PlanCompta from '../Pages/PlanCompta';
import IntCompte from '../Pages/IntCompte';
import RappBanque from '../Pages/RappBanque';
import Immobilisation from '../Pages/Immobilisation';
import Budget from '../Pages/Budget';
import SaisieCotisations from '../Pages/SaisieCotisations';
import ReglementFacture from '../Pages/ReglementFacture';
import Retenue from '../Pages/Retenue';
import Remboursements from '../Pages/Remboursements';
import Suspensions from '../Pages/Suspensions';
import EtatComptaFin from '../Pages/EtatComptaFin';
import GestionPaie from '../Pages/GestionPaie';
import ReportExport from '../Pages/ReportExport';
import Bulletins from '../Pages/Bulletins';
import Utilisateurs from '../Pages/Utilisateurs';
import EditPage from '../Pages/EditPage';
import InfosGen from '../Pages/InfosGen';
import TextReglement from '../Pages/TextReglement';
import Profil from '../Pages/Profil';
import { useAuth } from './useContext';

const getRoutesByProfil = (profil) => {
    switch (profil) {
        case 'role_1':
            return (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/donnees_bases" element={<DonneesBases />} />
                    <Route path="/tauxpc" element={<Tpec />} />
                    <Route path="/adherents" element={<Adherents />} />
                    <Route path="/fichiers/societes" element={<DemandeAdhs />} />
                    <Route path="/participants" element={<Participants />} />
                    <Route path="/participants/view/:numcont" element={<DetailsParticipant />} />
                    <Route path="/participants/edit/:numcont" element={<EditParticipant />} />
                    <Route path="/fournisseurs" element={<FournisseursSoins />} />
                    <Route path="/fournisseurs/view/:numFourn" element={<ViewFournisseurPage />} />
                    <Route path="/fournisseurs/edit/:numFourn" element={<EditFournisseur />} />
                    <Route path="/bons_pharmacies" element={<BonsPharma />} />
                    <Route path="/lettres_garanties" element={<Lettregarant />} />
                    <Route path="/lg_hospitalisation" element={<LgHospi />} />
                    <Route path="/bons_optiques" element={<BonsOptique />} />
                    <Route path="/factures_societes" element={<FacsSocs />} />
                    <Route path="/ordre_paiement" element={<OrdrePaie />} />
                    <Route path="/plancompta" element={<PlanCompta />} />
                    <Route path="/rapport_banque" element={<RappBanque />} />
                    <Route path="/interrogation_compte" element={<IntCompte />} />
                    <Route path="/cotisations" element={<SaisieCotisations />} />
                    <Route path="/reglements" element={<ReglementFacture />} />
                    <Route path="/etat_comptafin" element={<EtatComptaFin />} />
                    <Route path="/retenues" element={<Retenue />} />
                    <Route path="/remboursements" element={<Remboursements />} />
                    <Route path="/suspensions" element={<Suspensions />} />
                    <Route path="/journal-central" element={<JournalCentral />} />
                    <Route path='/saisie_journal' element={<SaisieJournal />}></Route>
                    <Route path='/immobilisation' element={<Immobilisation />}></Route>
                    <Route path='/budget' element={<Budget />}></Route>
                    <Route path="/bulletins" element={<Bulletins />} />
                    <Route path="/gestion-paie" element={<GestionPaie />} />
                    <Route path="/bon_achat" element={<BonsAchat />} />
                    <Route path="/reporting" element={<ReportExport />} />
                    <Route path="/profil" element={<Profil />} />
                    <Route path="/factures" element={<Factures />} />
                    <Route path="/factures/show/:numenreg" element={<TraitementFacture />} />
                    <Route path="/users" element={<Utilisateurs />} />
                    <Route path="/infosgen" element={<InfosGen />} />
                    <Route path="/gestion-paie/edit/:numbull" element={<EditPage />} />
                    <Route path="/text&reglement" element={<TextReglement />} />
                </Routes>
            );
        case 'role_15':
            return (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/bons_pharmacies" element={<BonsPharma />} />
                    <Route path="/lettres_garanties" element={<Lettregarant />} />
                    <Route path="/lg_hospitalisation" element={<LgHospi />} />
                    <Route path="/bons_optiques" element={<BonsOptique />} />
                </Routes>
            );
        case 'role_2':
            return (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/etat_comptafin" element={<EtatComptaFin />} />
                    <Route path="/retenues" element={<Retenue />} />
                    <Route path="/remboursements" element={<Remboursements />} />
                    <Route path="/suspensions" element={<Suspensions />} />
                    <Route path="/journal-central" element={<JournalCentral />} />
                    <Route path="/bulletins" element={<Bulletins />} />
                    <Route path="/gestion-paie" element={<GestionPaie />} />
                </Routes>
            );
        case 'role_3':
            return (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/donnees_bases" element={<DonneesBases />} />
                    <Route path="/tauxpc" element={<Tpec />} />
                    <Route path="/adherents" element={<Adherents />} />
                    <Route path="/fichiers/societes" element={<DemandeAdhs />} />
                    <Route path="/participants" element={<Participants />} />
                    <Route path="/participants/view/:numcont" element={<DetailsParticipant />} />
                    <Route path="/participants/edit/:numcont" element={<EditParticipant />} />
                    <Route path="/fournisseurs" element={<FournisseursSoins />} />
                    <Route path="/fournisseurs/view/:numFourn" element={<ViewFournisseurPage />} />
                    <Route path="/fournisseurs/edit/:numFourn" element={<EditFournisseur />} />
                </Routes>
            );
        case 'role_4':
        case 'role_5':
            return (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                </Routes>
            );
        default:
            return (
                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                </Routes>
            );
    }
};

export default function AppRoutes() {
    const { state } = useAuth();

    if (!state.isAuthenticated || !state.profil) {
        return <div>Loading...</div>;
    }

    return (
        <>
            {getRoutesByProfil(state.profil.profil)}
        </>
    );
  } */
